import React, { Fragment, lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { PortfolioDetailPage } from './component/Portfolio/PortfolioDetail'
import { BlogDetailPage } from './component/Blog/BlogDetail'
import Loader from './common/Loader'
import AdminLayout from './layout/AdminLayout'
import ProtectedRoute from './ProtectedRoute'
import Dashboard from './component/admin/dashboard/Dashboard'
import { EnquiriesPage } from './component/admin/EnquiriesPage'
const HomePage = lazy(() => import('./component/Home/Home'));
const AboutPage = lazy(() => import('./component/About/About'));
const PortfolioPage = lazy(() => import('./component/Portfolio/Portfolio'));
const ContactPage = lazy(() => import('./component/Contact/ContactPage'));
const BlogPage = lazy(() => import('./component/Blog/Blog'));
const TermsPage = lazy(() => import('./common/TermsPage'));
const PrivacyPage = lazy(() => import('./common/PrivacyPage'));
const CookiePage = lazy(() => import('./common/CookiePage'));
const ServiceDetail = lazy(() => import('./component/services/ServiceDetail'));
const WebDevelopmentService = lazy(() => import('./component/services/Sections/WebDevelopmentService'));
const MobileDevelopmentService = lazy(() => import('./component/services/Sections/MobileDevelopmentService'));
const AISolutionsService = lazy(() => import('./component/services/Sections/AISolutionsService'));
const UIUXDesignService = lazy(() => import('./component/services/Sections/UIUXDesignService'));
const EcommerceSolutionsService = lazy(() => import('./component/services/Sections/EcommerceSolutionsService'));
const HireDedicatedService = lazy(() => import('./component/services/Sections/HireDedicatedService'));
const ITConsultingService = lazy(() => import('./component/services/Sections/ITConsultingService'));
const AmazonAccountManagementService = lazy(() => import('./component/services/Sections/AmazonAccountManagementService'));
const AdvertisingPPCService = lazy(() => import('./component/services/Sections/AdvertisingPPCService'));
const AmazonBrandRegistryService = lazy(() => import('./component/services/Sections/AmazonBrandRegistryService'));
const AmazonEnhancedContentService = lazy(() => import('./component/services/Sections/AmazonEnhancedContentService'));
const NotFoundPage = lazy(() => import('./common/NotFoundPage'));
const CareersPage = lazy(() => import('./component/career/CareersPage'));
const CloudService = lazy(() => import('./component/services/Sections/CloudService'));
const DigitalMarketingService = lazy(() => import('./component/services/Sections/DigitalMarketingService'));

const MainLayout = lazy(() => import('./layout/MainLayout'));
const AdminLogin = lazy(() => import('./component/admin/AdminLogin'));

const Router = () => {
  return (
    <Fragment>
      <Suspense fallback={<Loader/>}>
        <Routes>
          <Route element={<MainLayout/>}>
            <Route path={"/"} element={<HomePage />} />
            <Route path={"about"} element={<AboutPage />} />
            <Route path={"services"} element={<ServiceDetail />} />
            <Route path={"services/web-development-service"} element={<WebDevelopmentService />} />
            <Route path={"services/mobile-development-service"} element={<MobileDevelopmentService />} />
            <Route path={"services/ai-solutions-service"} element={<AISolutionsService />} />
            <Route path={"services/ui-ux-design-service"} element={<UIUXDesignService />} />
            <Route path={"services/e-commerce-development-service"} element={<EcommerceSolutionsService />} />
            <Route path={"services/hire-dedicated-service"} element={<HireDedicatedService />} />
            <Route path={"services/it-consulting-service"} element={<ITConsultingService />} />
            <Route path={"services/digital-marketing-service"} element={<DigitalMarketingService />} />
            <Route path={"services/advertising-ppc-service"} element={<AdvertisingPPCService />} />
            <Route path={"services/cloud-services"} element={<CloudService />} />
            <Route path={"services/amazon-account-management-service"} element={<AmazonAccountManagementService />} />
            <Route path={"services/amazon-brand-registry-service"} element={<AmazonBrandRegistryService />} />
            <Route path={"services/amazon-enhanced-content-service"} element={<AmazonEnhancedContentService />} />
            <Route path={"portfolio"} element={<PortfolioPage />} />
            <Route path={"portfolio/:id"} element={<PortfolioDetailPage />} />
            <Route path={"blog"} element={<BlogPage />} />
            <Route path={"blog/:id"} element={<BlogDetailPage />} />
            <Route path={"contact"} element={<ContactPage />} />
            <Route path={"career"} element={<CareersPage />} />
            <Route path={"terms-condition"} element={<TermsPage />} />
            <Route path={"privacy-policy"} element={<PrivacyPage />} />
            <Route path={"cookie-policy"} element={<CookiePage />} />
            <Route path={"*"} element={<NotFoundPage />} />
          </Route>
          <Route path={"metafox-admin/signin"} element={<AdminLogin />} />
          <Route
            path="/metafox-admin"
            element={
              localStorage.getItem("admin_token")
                ? <Navigate to="/metafox-admin/dashboard" replace />
                : <Navigate to="/metafox-admin/login" replace />
            }
          />
          <Route
            path="/metafox-admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="login" element={<Dashboard />} />
            <Route path="enquiries" element={<EnquiriesPage />} />
          </Route>
        </Routes>
        </Suspense>
    </Fragment>
  )
}

export default Router
